import "./loading.css";

const Loading = (props) => {
  return (
    <div>
      <div className={"loader"}></div>
    </div>
  );
};

export { Loading };
